<template>
	<div class="page" data-name="cgl-study-detail-info">
		<f7-navbar>
			<div class="title">
				이번달 청구요금상세
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>
		<div class="page-content" style="background-color:#efeff4">
			<div class="block-title">청구 상세내역</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list no-hairlines-between">
						<ul>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">온라인 사용료 :</div>
										<div class="item-after"><b>594,000원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">교재 :</div>
										<div class="item-after"><b>182,000원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">기타 :</div>
										<div class="item-after"><b>0원</b></div>
									</div>
								</div>
							</li>							
						</ul>
					</div>
				</div>
	 			<div class="card-footer">
					<span class="color-black"><b>매출 계(A) :</b></span>
					<span><h3><b style="color:#00aaff">776,000원</b></h3></span>
				</div>
			</div>

			<div class="block-title">정산내역</div>
			<div class="card card-outline">
				<div class="card-content card-content-padding">
					<div class="list no-hairlines-between">
						<ul>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">전월 청구액(B) :</div>
										<div class="item-after"><b>313,250원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner"> 
										<div class="item-title">카드결제(C1) :</div>
										<div class="item-after"><b>923,500원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">CMS+무통장(C2) :</div>
										<div class="item-after"><b>0원</b></div>
									</div>
								</div>
							</li>
							<li>
								<div class="item-content">
									<div class="item-inner">
										<div class="item-title">기타(D) :</div>
										<div class="item-after"><b>0원</b></div>
									</div>
								</div>
							</li>			
						</ul>
					</div>
				</div>
				<div class="card-footer">
					<span class="color-black"><b>잔액(A+B-(C1+C2+D)) :</b></span>
					<span><h3><b style="color:#00aaff">165,750원</b></h3></span>
				</div>
			</div>

			<div class="block-title">사용내역</div>
			<div class="data-table data-table-init card">
				<table>
					<thead>
					 <tr>
							<th class="label-cell">카드명</th>
							<th class="numeric-cell">결제일</th>
							<th class="numeric-cell">승인번호</th>							
							<th class="numeric-cell">승인</th>
							<th class="numeric-cell">결제금액</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="label-cell">비씨</td>
							<td class="numeric-cell">20.05.21</td>		
							<td class="numeric-cell">78513000</td>												
							<td class="numeric-cell">승인</td>
							<td class="numeric-cell">40,000</td>
						</tr>
						<tr>
							<td class="label-cell">비씨</td>
							<td class="numeric-cell">20.05.21</td>		
							<td class="numeric-cell">78513000</td>												
							<td class="numeric-cell">승인</td>
							<td class="numeric-cell">40,000</td>
						</tr>
						<tr>
							<td class="label-cell">비씨</td>
							<td class="numeric-cell">20.05.21</td>		
							<td class="numeric-cell">78513000</td>												
							<td class="numeric-cell">승 인</td>
							<td class="numeric-cell">40,000</td>
						</tr>
						<tr>
							<td class="label-cell">비씨</td>
							<td class="numeric-cell">20.05.21</td>		
							<td class="numeric-cell">78513000</td>												
							<td class="numeric-cell">승인</td>
							<td class="numeric-cell">40,000</td>
						</tr>
						<tr>
							<td class="label-cell">비씨</td>
							<td class="numeric-cell">20.05.21</td>		
							<td class="numeric-cell">78513000</td>												
							<td class="numeric-cell">승인</td>
							<td class="numeric-cell">40,000</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { f7 } from 'framework7-vue';
import MODULE from '../../../../js/common/module';
import PAGES from '../../../../js/pages';
import CONST from '../../../../js/common/constant';
import API from '../../../../js/common/api';
import AUTH from '../../../../js/common/auth';
import Chart from 'chart.js';

export default {
  data() {
    return {

    }
  },
  mounted() {
    const _this = this;
	 
  },
  methods: {

  }
}

</script>
